export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TEXT = 'TEXT',
  TERTIARY = 'TERTIARY',
  BUTTON_TYPE_UNSPECIFIED = 'BUTTON_TYPE_UNSPECIFIED',
  BASE = 'BASE',
}

export type ButtonAction =
  | 'UNKNOWN'
  | 'SUBMIT'
  | 'CANCEL'
  | 'NEXT'
  | 'BACK'
  | 'HOMEPAGE'
  | 'SETTINGS'
  | 'SIGN_OUT'
  | 'UPDATE_PRIMARY_USER'
  | 'UPDATE_BUSINESS_NAME';

export enum ButtonActionType {
  UNKNOWN = 'UNKNOWN',
  SUBMIT = 'SUBMIT',
  CANCEL = 'CANCEL',
  NEXT = 'NEXT',
  BACK = 'BACK',
  HOMEPAGE = 'HOMEPAGE',
  SETTINGS = 'SETTINGS',
  SIGN_OUT = 'SIGN_OUT',
}
